
export const DefaultProfileImage = "default_profile";



// WEBPACK FOOTER //
// ./public/utils/ImageUtils.js